import { IconButton } from '@mui/material';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { DynamicIcon, Tooltip } from 'src/components';
import { PersonalizeSidePanelModal } from 'src/components/SidePanelPersonalization/PersonalizeSidePanelModal/personalize-side-panel-modal';
import { useGroupRules, UserGroupRules } from 'src/graphql';
import {
  floatingPanelToolSx,
  useSidePanelToolsSlot,
} from 'src/pages/Conversations/SidePanel/side-panel-tools-slot';

// gated tune button + the shared modal; renders inside a
// SidePanelPersonalizationProvider, which supplies the surface. When a
// floating tools slot is provided (side panels built from SidePanelCard),
// the button portals there; otherwise it falls back to rendering inline so
// hosts without a tools slot (e.g. mobile) still get a reachable button.
export const PersonalizeSidePanelButton = () => {
  const { checkValidity } = useGroupRules();
  const canPersonalize = checkValidity([UserGroupRules.AccessToPersonalizeSidepanel]);
  const [open, setOpen] = useState(false);
  const toolsSlot = useSidePanelToolsSlot();

  if (!canPersonalize) {
    return null;
  }

  const button = (
    <Tooltip title="Personalize this view">
      <IconButton
        size="small"
        onClick={() => setOpen(true)}
        aria-label="Personalize this view"
        data-testid="personalize-side-panel-open"
        sx={toolsSlot ? floatingPanelToolSx : undefined}
      >
        <DynamicIcon name="sliders-horizontal" library="lucide" size={16} />
      </IconButton>
    </Tooltip>
  );

  return (
    <>
      {toolsSlot ? createPortal(button, toolsSlot) : button}
      <PersonalizeSidePanelModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};
